/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfDirectoryResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfDirectoryResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /directories/archived
 */
export interface ArchivedRequestBuilder extends BaseRequestBuilder<ArchivedRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfDirectoryResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ArchivedRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfDirectoryResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ArchivedRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface ArchivedRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
    search?: string;
}
/**
 * Uri template for the request builder.
 */
export const ArchivedRequestBuilderUriTemplate = "{+baseurl}/directories/archived{?page*,pageSize*,search*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ArchivedRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ArchivedRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfDirectoryResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
